<template>
  <div
    v-show="isLoaded"
    class="mapContainer"
  >
    <img
      :src="generateUrl"
      @error="imageError"
      @load="onImgLoad"
    >
  </div>
</template>

<script>
export default {
  props: {
    apiKey: {
      type: String,
      required: false,
      default: '',
    },
    street1: {
      type: String,
      required: false,
      default: '',
    },
    street2: {
      type: String,
      required: false,
      default: '',
    },
    city: {
      type: String,
      required: true,
      default: '',
    },
    state: {
      type: String,
      required: true,
      default: '',
    },
    zipCode: {
      type: String,
      required: true,
      default: '',
    },
  },
  data: () => ({
    isLoaded: false,
  }),
  computed: {
    generateUrl() {
      return `https://maps.googleapis.com/maps/api/staticmap?center=${this.street1 ? `${this.street1},` : ''}${this.street2 ? `+${this.street2},` : ''}${this.city ? `+${this.city},` : ''}${this.state ? `+${this.state},` : ''}${this.zipCode ? `+${this.zipCode},` : ''}&zoom=10&scale=2&size=300x200&maptype=roadmap&key=${this.apiKey}&format=png&visual_refresh=true&markers=size:mid%7Ccolor:0xff0000%7Clabel:1%7C${this.street1 ? `${this.street1},` : ''}${this.street2 ? `+${this.street2},` : ''}${this.city ? `+${this.city},` : ''}${this.state ? `+${this.state},` : ''}${this.zipCode ? `+${this.zipCode}` : ''}`;
    },
  },
  methods: {
    onImgLoad() {
      this.isLoaded = true;
    },
    imageError() {
      this.isLoaded = false;
    },
  },
};
</script>

<style>
.mapContainer {
  margin-bottom: 20px;
  width:100%;
  max-height:clamp(200px, 50%, 400px);
  overflow:hidden;
}
.mapContainer>img {
  width:100%;
  object-fit:cover;
  object-position: center center;
}
</style>
